const state = {
    // 用户车辆
    carList: [],
    // 用户驾照
    drivingList: [],
    // 违章车辆列表选中id
    carId: -1,
    // 驾照列表选中id
    drivingId: -1
}
export default state